import { Vue, Component, Prop } from 'vue-property-decorator';
import { IModalComponent, Btn, Field, TextareaField } from '@samc/centricity-core';
import { IAddInternalCommentToLoansRequest } from '@/Interfaces';
import { AjaxHelper, errToMessage, getToken } from '@samc/common';
import { zonedTimeToUtc } from 'date-fns-tz';

@Component({
  name: 'add-internal-comment-to-loans-modal',
  components: { TextareaField, Btn, Field }
})
export default class AddInternalCommentToLoansModal extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<any>) => void;
  @Prop() public closeProp!: () => void;
  @Prop({ default: [] }) public loanIdsList!: number[];
  @Prop() public internalUrl!: string;
  @Prop() public verificationToken!: string;
  @Prop() public user!: string;
  public ajaxHelper: AjaxHelper | null = null;

  public comment: string = '';
  public inprogress: boolean = false;

  public mounted() {
    this.ajaxHelper = new AjaxHelper(this.internalUrl, this.verificationToken, null, getToken());
  }

  public async addCommentToLoans() {
    try {
      this.validateInputs();

      if (this.warningMsg.length > 0)
      {
        this.$alert({
          title: 'Validation Failed',
          description: 'Please read below for details',
          type: 'error',
          errors: this.warningMsg.slice(0, 10)
        });

        this.warningMsg = [];
        return;
      }

      const modifiedDate = zonedTimeToUtc(new Date(), window.__UI_TIMEZONE);
      const request = { comment: this.comment, loanIdList: this.loanIdsList, modifiedTime: modifiedDate, modifiedBy: this.user } as IAddInternalCommentToLoansRequest;

      if (!request) return;

      this.$loading('Adding comment...');
      const response = await this.ajaxHelper?.postData<number>('componentapi/comments/addCommentToLoans', request);

      this.$alert.success(`Successfully added comment to ${this.loanIdsList.length} ` + (this.loanIdsList.length > 1 ? 'loans' : 'loan') + '.');
      this.closeProp();
    } catch (err) {
        this.$log(err);
        this.$alert({
          type: 'error',
          title: `Failed to add comment to selected ${this.loanIdsList.length > 1 ? 'loans' : 'loan'}.`,
          description: 'For more detailed information, please contact support team.',
          errors: errToMessage(err),
          closingOption: 'holdOpen'
        });
      } finally {
        this.$loading();
        this.inprogress = false;
        this.warningMsg = [];
      }
  }

  private warningMsg: string[] = [];

  private validateInputs() {
    this.warningMsg = [];

    if (this.loanIdsList.length === 0)
      this.warningMsg.push('Please select at least one loan to add comment.');

    if (!this.comment)
      this.warningMsg.push(`Comment cannot be empty for selected ${this.loanIdsList.length > 1 ? 'loans' : 'loan'}.`);
  }
}
